'use client';

import { useState, useRef, useEffect, MouseEvent } from 'react';
import { createPortal } from 'react-dom';
import { AvatarIcon, CloseIcon } from '@/components/icons';
import { TourFilter } from '@/components/filters/TourFilter';
import { AvatarName } from '../ProfileDropdown/AvatarName';
import './profileModal.css';
import { MobileLoginForm } from './MobileLoginForm';
import { useAuthModal } from '@/lib/context/AuthModalContext';
import { ProfileModalContent } from './ProfileModalContent';
import { useSession } from 'next-auth/react';

const delay = 300;

export const ProfileModal = () => {
  const { data: session } = useSession();
  const [formType, setFormType] = useState<'login' | 'register'>('login');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const filterModalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isOpen && filterModalRef.current) {
      setTimeout(() => {
        if (filterModalRef.current) filterModalRef.current.classList.add('profile-modal-open');
      }, 0);
    }
  }, [isOpen]);

  const handleOpen = () => {
    document.body.style.overflow = 'hidden';
    setIsOpen(true);
  };

  const handleClose = (event: MouseEvent<HTMLDivElement> | null = null) => {
    if (event) {
      const target = event.target as HTMLElement;
      const isModalContent = target.closest('.profile-modal__content');
      const isCloseButton = target.closest('.profile-modal__close');

      if (!filterModalRef.current || (!isCloseButton && isModalContent)) {
        return;
      }
    }
    document.body.style.overflow = '';
    filterModalRef.current?.classList.remove('profile-modal-open');
    setTimeout(() => {
      setIsOpen(false);
    }, delay);
  };

  const switchForm = () => setFormType((prevType) => (prevType === 'login' ? 'register' : 'login'));

  return (
    <>
      <div onClick={handleOpen}>{!!session ? <AvatarName /> : <AvatarIcon />}</div>

      {isOpen &&
        createPortal(
          <div
            ref={filterModalRef}
            onClick={handleClose}
            className={`profile-modal ${!!session ? 'justify-center' : 'justify-end'}`}
          >
            <div className={`profile-modal__content bg-gray-900 ${!!session ? 'authenticated' : ''}`}>
              <div className="sticky lg:relative flex justify-end p-4 bg-gray-900 top-0 ">
                <div onClick={handleClose} className="p-[5px] cursor-pointer profile-modal__close">
                  <CloseIcon />
                </div>
              </div>

              {/* isAuthenticated ? show profile menu items : show login form */}
              <ProfileModalContent formType={formType} switchForm={switchForm} handleClose={() => setIsOpen(false)} />
              {/* <MobileLoginForm /> */}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
